/**
 * @desc 查询多个品牌信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductBrandResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/brand/selectByBrands`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
